export default "/images/5da3482945cb862bc9c163ce9fa4864d.avif";